module.exports = __webpack_public_path__ + "static/img/mt_order_icon.34d24e20.png";